module.exports = __webpack_public_path__ + "img/functional2-img8.3eee0379.png";